import { IShiftFunction2Point } from '../ShiftFunction2Point';

export interface IShiftFunction4Point extends IShiftFunction2Point {
    flow1: number;
    flow2: number;
    outT1: number;
    outT2: number;

}

export type  ILine = {
    lines: 
        {
            name: string,
            points:  IPoint[],
            key: any
        }[]
}
export type  IPoint = {
    x: number,
    y: number
}
export const schema = 'AutomationApps.Functions.SetPoints.ShiftFunction4Point';


    